import { linter } from '@codemirror/lint';
import { parseTree, getNodeValue, printParseErrorCode } from 'jsonc-parser';

export function parseJSON(value) {
  const errors = [];
  const root = parseTree(value, errors, { allowTrailingComma: true });

  return {
    json: errors.length > 0 ? null : getNodeValue(root),
    errors,
  };
}

export function getErrorMessage(errorCode) {
  const error = printParseErrorCode(errorCode);
  const withSpaces = error.replace(/([A-Z])/g, ' $1').trim();

  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1).toLowerCase();
}

const jsonLinter = linter((view) => {
  const value = view.state.doc.toString();
  const diagnostics = [];
  const { errors } = parseJSON(value);

  for (const error of errors) {
    diagnostics.push({
      from: error.offset,
      to: error.offset + error.length,
      severity: 'error',
      message: getErrorMessage(error.error),
    });
  }

  return diagnostics;
});

export default jsonLinter;
